import { eventBus, EVENTS } from '../commons/EventBus.js';
import { Slider } from '../commons/slider.js';

eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
  const template=data.template;

  if((template!='home'&&template!='homepage'&&template!='')||data.refresh){
    return;
  }
  $('#player-card').click(openSerieAVideoPlayer);

  // $('#player-card').click(openSerieAVideoPlayer);
    // $("#Home-menu").addClass("selected");

  new Slider({
      total: $(".single_slide_home").length,
      paginator_cont: $("#paginator_slider_home"),
      cssVar: '--slider_home',
      slide_cont: 'slide_container_home',
      swipeElementSelector: '#homepage-simple_slide'});
});

function openSerieAVideoPlayer(e){
  e.preventDefault();
  changeRadio(13);
  toggleAudioVideoPlayer(1);
  toggleDirettaVideo();
}

$(document).on('click', '.player-card', openSerieAVideoPlayer);
